import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';

export const FadeInWhenVisibleLeft = ({ children }) => {
	const controls = useAnimation();
	const [ref, inView] = useInView();
  
	useEffect(() => {
	  if (inView) {
		controls.start("visible");
	  }
	}, [controls, inView]);
  
	return (
	  <motion.div
	  ref={ref}
      animate={controls}
      initial="hidden"
      transition={{ duration: 1 }}
      variants={{
		hidden: { opacity: 0, x: -100 },
		visible: { opacity: 1, x: 0 }
      }}
		
	  >
		{children}
	  </motion.div>
	);
  }

  export const FadeInWhenVisibleRight = ({ children }) => {
	const controls = useAnimation();
	const [ref, inView] = useInView();
  
	useEffect(() => {
	  if (inView) {
		controls.start("visible");
	  }
	}, [controls, inView]);
  
	return (
	  <motion.div
	  ref={ref}
      animate={controls}
      initial="hidden"
      transition={{ duration: 1 }}
      variants={{
		hidden: { opacity: 0, x: 100 },
		visible: { opacity: 1, x: 0 }
      }}
		
	  >
		{children}
	  </motion.div>
	);
  }

  FadeInWhenVisibleRight.propTypes = {
	children: PropTypes.element
};

FadeInWhenVisibleLeft.propTypes = {
	children: PropTypes.element
};
